import BasePMPExcludedComplete from "../../basePMPExcluded/basePMPExcludedComplete";

export default class ApplyPMPExcludedComplete extends BasePMPExcludedComplete {
  handleReturnPageName = () => {
    return "Apply for PMP Excluded";
  };
}
